import { AttendContactAbsenceFactory } from './attendContactAbsenceFactory';

import type {
  AttendContactAbsenceEntity,
  AttendContactAbsencePropsPub,
  AttendContactAbsencePropsPvt,
} from './attendContactAbsenceEntity';
import type { AttendContactAbsenceIRepository } from './attendContactAbsenceIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { AttendContactAbsenceJsonPub, AttendContactAbsenceJsonPvt } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class AttendContactAbsenceRepository extends AppsyncRepository<
  AttendContactAbsenceEntity,
  AttendContactAbsencePropsPvt,
  AttendContactAbsenceJsonPvt,
  AttendContactAbsencePropsPub,
  AttendContactAbsenceJsonPub
> implements AttendContactAbsenceIRepository {
  private factory = new AttendContactAbsenceFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryAttendContactAttendContactAbsenceEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
